import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAppData } from '../context/AppContext';
import supabase from '../supabase/supabase';
import ProfileSettings from './Profile/ProfileSettings';

export default function Layout({ activeView, setActiveView, children }) {
  const { profile, isSaving } = useAppData();
  const [showProfile, setShowProfile] = useState(false);

  const handleLogout = () => supabase.auth.signOut();

  return (
    <div className="flex flex-col h-screen bg-app-bg text-app-text font-sans selection:bg-app-accent selection:text-black">
      <header className="h-20 border-b border-app-border bg-app-surface flex items-center justify-between px-4 md:px-6 shrink-0 z-10">
        <div className="flex items-center">
          <div className="flex items-center gap-3 mr-4 md:mr-8">
            <div className="bg-white rounded-lg p-2 shadow-sm">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/981ecb6892631c31e92fca6d10d0332603596e5d429fd99cee63046a83be378b4365dffb7696bc6c52f453f1ea7f8977/images/aW1hZ2UvcG5n/4b0d0eb086c78be5a6191d6981f9870f.png" 
                alt="SharePrepare Toucan" 
                className="h-12 object-contain" 
              />
            </div>
          </div>
          
          <nav className="flex h-full">
            <button 
              onClick={() => setActiveView('watchlists')}
              className={`h-20 px-3 md:px-5 flex items-center border-b-2 transition-all text-[10px] md:text-xs font-black uppercase tracking-widest ${
                activeView === 'watchlists' 
                  ? 'border-app-accent text-app-accent' 
                  : 'border-transparent text-app-muted hover:text-white'
              }`}
            >
              Watchlists
            </button>
            <button 
              onClick={() => setActiveView('planner')}
              className={`h-20 px-3 md:px-5 flex items-center border-b-2 transition-all text-[10px] md:text-xs font-black uppercase tracking-widest ${
                activeView === 'planner' 
                  ? 'border-app-accent text-app-accent' 
                  : 'border-transparent text-app-muted hover:text-white'
              }`}
            >
              Daily Planner
            </button>
            {profile?.role === 'admin' && (
              <button 
                onClick={() => setActiveView('admin')}
                className={`h-20 px-3 md:px-5 flex items-center border-b-2 transition-all text-[10px] md:text-xs font-black uppercase tracking-widest ${
                  activeView === 'admin' 
                    ? 'border-app-accent text-app-accent' 
                    : 'border-transparent text-app-muted hover:text-white'
                }`}
              >
                Admin
              </button>
            )}
          </nav>
        </div>

        <div className="flex items-center gap-3 md:gap-5">
          {/* Saving Indicator */}
          <div className={`flex items-center gap-2 px-3 py-1 rounded-full bg-app-bg border border-app-border transition-opacity duration-300 ${isSaving ? 'opacity-100' : 'opacity-0'}`}>
            <FiIcons.FiLoader size={12} className="animate-spin text-app-accent" />
            <span className="text-[9px] font-black uppercase tracking-widest text-app-muted">Syncing</span>
          </div>

          <div className={`flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-widest border shadow-sm ${
            profile?.role === 'admin' 
              ? 'bg-app-accent text-black border-app-accent' 
              : 'bg-app-surface text-app-muted border-app-border'
          }`}>
            {profile?.role === 'admin' && <FiIcons.FiShield size={10} />}
            {profile?.role || 'User'}
          </div>

          <button 
            onClick={() => setShowProfile(true)}
            className="flex items-center gap-2 hover:bg-app-border/50 p-1 rounded-full transition-all group border border-transparent hover:border-app-border"
          >
            <div className="w-8 h-8 rounded-full border border-app-border overflow-hidden bg-app-bg shrink-0">
              {profile?.avatar_url ? (
                <img src={profile.avatar_url} alt="User" className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-app-muted">
                  <FiIcons.FiUser size={16} />
                </div>
              )}
            </div>
          </button>
          
          <button 
            onClick={handleLogout}
            className="text-app-muted hover:text-app-red transition-colors p-2"
            title="Log Out"
          >
            <FiIcons.FiLogOut size={18} />
          </button>
        </div>
      </header>

      <main className="flex-1 overflow-hidden relative">
        {children}
      </main>

      {showProfile && <ProfileSettings onClose={() => setShowProfile(false)} />}
    </div>
  );
}